<div class="row offset-md-1">
  <div class="">
    <div class="text-left">
      <h1 class="title">
        <span>MANAGE ABSTRACTS FOR RECONCILIATION: <strong>{{activeProjectTitle}}</strong></span>
      </h1>
    </div>
  </div>
  <div class="manage-rec-body-container">
    <div class="left-col">
      <!-- Manage QC Mode: Begin -->
      <div class="filter-rec-container">
        <!-- Date drop down -->
        <div class="manage-rec-filter">
          <label for="startDate">QC Coded in Week</label>
          <br />
          <mat-form-field floatLabel="never" style="width:270px !important;">
            <mat-select matNativeControl [(value)]="selectedWeek" (selectionChange)="updateDateRange($event)" name="startDate"
              placeholder="Select">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let date of dates" [value]="date.value">{{date.text + ' (' + date.week + ')'}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Select list -->
        <div class="manage-rec-filter">
          <label for="currview">View Unreconciled Abstracts</label>
          <br />
          <mat-form-field style="width:300px !important;">
            <mat-select matNativeControl #matSelectQCFilter [(value)]="filterOptionSelected" name="currview"
              title="Filters list" required>
              <mat-option *ngFor="let option of filteroptions" [value]="option.name"
                (click)="filterSelected(option)">{{option.displayText}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Exclude Coder drop down -->
        <div class="manage-rec-filter">
          <label for="exclCoder">Exclude Coders for Auto-Sampling</label>
          <br />
          <mat-form-field floatLabel="never" style="width:225px !important;">
            <mat-select matNativeControl #matExcludeCoders [(value)]="selectedCoders" (closed)="excludeUsers($event)"
              name="exclCoder" title="Coder" [disabled]="!this.selectedWeek || this.filterOptionSelected != 'qceligible'" multiple required>
              <mat-option *ngFor="let coder of westatCoders" [value]="coder.id">
                {{ coder.firstName + ' ' + coder.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="auto-config-container" *ngIf="this.filterOptionSelected == 'qceligible'">
        <div class="auto-config-table">
          <p><strong>Configure Auto Sample: </strong>(Note: Abstracts with QC Coder Questions will not be auto sampled.)</p>
          <div class="auto-config-header-row">
            <div class="auto-config-col-l">QC-Consensus/ML Agreement</div>
            <div class="auto-config-col-s"># Per Category</div>
            <div class="auto-config-col-s">% to Sample</div>
            <div class="auto-config-col-s">Expected Auto Sample #</div>
            <div class="auto-config-col-s">Actual Auto Sample #</div>
          </div>

          <div class="auto-config-body-row">
            <div class="auto-config-col-l">High Pri. Disagreement (X, A, B, E, F)</div>
            <div class="auto-config-col-s">{{this.abstractsData.highPriDisagreementCount}}</div>
            <div class="auto-config-col-s">
              <input [(ngModel)]="this.highPriDisagreementSamplePercent" appNumericInput
                (ngModelChange)="highDisagreePercentUpdate()"
                [disabled]="!this.selectedWeek || this.filterOptionSelected != 'qceligible'" type="number" min="0"
                max="100" class="form-field-right-align numeric-input">%
            </div>
            <div class="auto-config-col-s">{{this.highPriDisagreeAutoCount}}</div>
            <div class="auto-config-col-s">{{this.autoSampleHighPriDisagreeResultCount != 0 ? this.autoSampleHighPriDisagreeResultCount : ""}}</div>
          </div>

          <div class="auto-config-body-row">
            <div class="auto-config-col-l">Low Pri. Disagreement (C, D only)</div>
            <div class="auto-config-col-s">{{this.abstractsData.lowPriDisagreementCount}}</div>
            <div class="auto-config-col-s">
              <input appNumericInput type="number" min="0" max="100" class="form-field-right-align numeric-input"
                [disabled]="!this.selectedWeek || this.filterOptionSelected != 'qceligible'"
                [(ngModel)]="this.lowPriDisagreementSamplePercent" (ngModelChange)="lowDisagreePercentUpdate()">%
            </div>
            <div class="auto-config-col-s">{{this.lowPriDisagreeAutoCount}}</div>
            <div class="auto-config-col-s">{{this.autoSampleLowPriDisagreeResultCount != 0 ? this.autoSampleLowPriDisagreeResultCount : ""}}</div>
          </div>

          <div class="auto-config-body-row">
            <div class="auto-config-col-l">Full Agreement</div>
            <div class="auto-config-col-s">{{this.abstractsData.fullAgreementCount}}</div>
            <div class="auto-config-col-s">
              <input appNumericInput type="number" min="0" max="100" class="form-field-right-align numeric-input"
                [disabled]="!this.selectedWeek || this.filterOptionSelected != 'qceligible'"
                [(ngModel)]="this.fullAgreementSamplePercent" (ngModelChange)="fullAgreePercentUpdate()">%
            </div>
            <div class="auto-config-col-s">{{this.fullAgreeAutoCount}}</div>
            <div class="auto-config-col-s">{{this.autoSampleFullAgreeResultCount != 0 ? this.autoSampleFullAgreeResultCount : ""}}</div>
          </div>

          <div class="auto-config-footer-row">
            <div class="auto-config-col-l">Total</div>
            <div class="auto-config-col-s">{{this.eligibleAbstractsWithMlDataCount}} </div>
            <div class="auto-config-col-s"></div>
            <div class="auto-config-col-s">{{this.totalAutoSampleCount}}</div>
            <div class="auto-config-col-s">{{this.actualAbstractsInReconWithMlDataCount != 0 ? this.actualAbstractsInReconWithMlDataCount : ""}}</div>
          </div>
          <div style="font-size: 14px;">
            *Actual Sample #s may vary due to rounding and to ensure all mechanisms are represented.
          </div>
        </div>
        <div class="auto-config-details">
          <div *ngIf="this.selectedWeek">
            <p>
              <strong>Projected Sampling Ratio: *</strong><br />
              Expected Auto Sample # / Total = {{this.autoSelectPercent}}%
            </p>
            <button mat-button class="btn btn-primary" name="selectqclist" *ngIf="!qcViewQcList && !qcViewCoderQList"
              (click)="autoSampleAbstracts()"
              [disabled]="!this.selectedWeek || this.filterOptionSelected != 'qceligible' || this.isAutoSampling">
              Auto Sample Abstracts
            </button>
          </div>
        </div>
      </div>
      <div class="manual-update-container">
        <ng-container *ngIf="actionoptions.length > 0">
          <label for="actionopts" style="margin-top:auto;margin-bottom:auto;">Manually Select Abstracts To:</label>
          <mat-form-field floatLabel="never" style="width: 375px" class="hide-subscript">
            <mat-select matNativeControl required [(value)]="actionOptionSelected"
              (selectionChange)="actionChange($event.value)" name="actionopts">
              <mat-option *ngFor="let option of actionoptions" [value]="option.name">{{option.displayText}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <button mat-button class="btn btn-success"
          *ngIf="actionOptionSelected!='' && actionOptionSelected!='selectaction' && selection.selected.length >0"
          (click)="submitAction()">
          Submit
        </button>
      </div>
      <div *ngIf="this.filterOptionSelected == 'qceligiblereview' || this.filterOptionSelected == 'qceligiblecoderqrev'" class="pdf-print-text" >
        <!--To print the abstracts shown in table below to PDF or a printer<span *ngIf="this.filterOptionSelected == 'qceligiblecoderqrev'">*</span>:
        <ng-container *ngIf="this.filterOptionSelected == 'qceligiblecoderqrev'">
          <br>
          <span>* Includes QC Coder Question/Request ODP Adjudication options and QC Coder notes.</span>
        </ng-container>-->
        <button mat-button class="btn btn-primary print-btn" name="qclisttopdf"
                (click)="openPrintPdfWindow();$event.stopPropagation()">
          {{this.filterOptionSelected == 'qceligiblecoderqrev' ? "Open QC Coder Questions for Printing (With Notes/Flags)" : "Open Rec. List Abstracts for Printing (No Notes/Flags)"}}
        </button>
      </div>

    </div>
    <div class="right-col">
      <div class="summary-table">
        <div class="summary-table-header-row">
          <div class="summary-table-col-l">Summary</div>
          <div class="summary-table-col-s">Value</div>
        </div>
        <div class="summary-table-row">
          <div class="summary-table-col-l"># of Eligible Abstracts</div>
          <div class="summary-table-col-s">{{this.abstractsData.reconEligibleCount}}</div>
        </div>
        <div class="summary-table-row">
          <div class="summary-table-col-l"><strong>Total in Reconciliation List</strong></div>
          <div class="summary-table-col-s"><strong>{{this.abstractsData.inQCListCount}}</strong></div>
        </div>
        <div class="summary-table-row">
          <div class="summary-table-col-l summary-indent"># with QC Coder Questions (pre-selected by default)</div>
          <div class="summary-table-col-s">{{this.abstractsData.inCoderQAndReconListCount}}</div>
        </div>
        <div class="summary-table-row">
          <div class="summary-table-col-l summary-indent"># Sampled (auto or manual)</div>
          <div class="summary-table-col-s">{{this.currentSampleNumber}}</div>
        </div>
        <div class="summary-table-row">
          <div class="summary-table-col-l">Sampling Ratio (# Sampled / (Total Eligible - All QC Coder Questions))</div>
          <div class="summary-table-col-s">{{this.currentSampleRatio}}%</div>
        </div>
      </div>
      <div class="text-right search-container">
        <h6>Search</h6>
        <mat-form-field class="example-form-field hide-subscript">
          <input matInput id="searchInput" type="text" title="search box" [(ngModel)]="searchTerm"
            (keyup)="searchTermChange($event)">
          <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearSearchTerm()">
            <mat-icon>x</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <!-- Manage QC Mode: End -->
  </div>
  <div class="paginator-row">
    <div style="margin-top:auto;">
      <h5>Abstracts that have not gone through Reconciliation:</h5>
    </div>
    <div class="" *ngIf="showPaginator">
      <mat-paginator class="clear-paginator" #paginatorTop [length]="abstractsData.abstractCount" [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100, 250, 500]" [showFirstLastButtons]="true" [pageIndex]="pageIndex"
        (page)="pageIndex = $event.pageIndex; pageSize  = $event.pageSize ">
      </mat-paginator>
    </div>
  </div>
  <div class="no-padding">
    <div class="">
      <div class="example-container mat-elevation-z8">
        <div class="example-table-container">
          <div class="example-loading-shade" *ngIf="isLoadingResults"></div>
          <ag-grid-angular style="width: 100%;" [rowData]="abstractsData.abstractResult" [columnDefs]="colDefs"
            [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" />
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-5 offset-md-7 pull-right" *ngIf="showPaginator">
      <mat-paginator class="clear-paginator" #paginatorBottom [length]="abstractsData.abstractCount" [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100, 250, 500]" [showFirstLastButtons]="true" [pageIndex]="pageIndex"
        (page)="pageIndex = $event.pageIndex; pageSize = $event.pageSize">
      </mat-paginator>
    </div>

  </div>
</div>
